import React, { useState } from "react";
import dayjs from "dayjs";

import { isNullOrUndefined } from "../../HWLibrary/HWUtils";
import { s360ConfigService } from "../../Services/S360Config";

function MessageA78(props) {
  const [a78State, setA78State] = useState({
    timeSlot: props?.entry?.text_data?.names[0],
    selected: false
  });

  const handleChange = (e) => {
    console.log("time Selected!!");
    setA78State(prev => ({ ...prev, timeSlot: e.target.value }));
  }

  const onSubmit = (e) => {
    onMouseLeaveButton(e);
    setA78State(prev => ({ ...prev, value: false, selected: true }));
    props.actions.sendMessage(a78State.timeSlot);
  }
  const onMouseEnterButton = (e) => {
    if (!e.target) {
      return
    }
    if (e.target.disabled === true) {
      return
    }

    e.target.style.color = s360ConfigService.config?.customDesign?.messageA78ButtonMouseEnter.color ?? "#f8f5f5";
    e.target.style.backgroundColor = s360ConfigService.config?.customDesign?.messageA78ButtonMouseEnter.background ?? "#2935dd";
  }

  const onMouseLeaveButton = (e) => {
    if (!e.target) {
      return
    }

    e.target.style.color = s360ConfigService.config?.customDesign?.messageA78ButtonMouseLeave.color ?? "#0092ed";
    e.target.style.backgroundColor = s360ConfigService.config?.customDesign?.messageA78ButtonMouseLeave.background ?? "#fff";
  }
  const messageBoxSubmitStyle = () => {
    return {
      marginLeft: '20px',
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: "#0092ed",
      borderRadius: 20,
      color: "#0092ed",
      backgroundColor: "#fff",
      ...s360ConfigService.config?.customDesign?.messageA78Submit
    }
  }

  const onMouseEnter = (e) => {
    if (!e.target) {
      return
    }
    if (e.target.disabled === true) {
      return
    }

    e.target.style.color = s360ConfigService.config?.customDesign?.messageA78ButtonMouseEnter.color ?? "#f8f5f5";
    e.target.style.backgroundColor = s360ConfigService.config?.customDesign?.messageA78ButtonMouseEnter.background ?? "#2935dd";
  }

  const onMouseLeave = (e) => {
    if (!e.target) {
      return
    }

    e.target.style.color = s360ConfigService.config?.customDesign?.messageA78ButtonMouseLeave.color ?? "#0092ed";
    e.target.style.backgroundColor = s360ConfigService.config?.customDesign?.messageA78ButtonMouseLeave.background ?? "#fff";
  }

  const messageContainerClassName = () => {
    return props.config.autoFullScreen ? "s360-message-cotainer-received-fs" : "s360-message-cotainer-received";
  }


  const messageBoxStyle = () => {
    return {
      textAlign: 'left',
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: "#0092ed",
      width: "fit-content",
      borderRadius: 20,
      color: "#0092ed",
      backgroundColor: "#fff",
      fontWeight: "500",
      ...s360ConfigService.config?.customDesign?.messageA78Box
    }
  }

  const messageTimeStyle = () => {
    let config = props.config;
    return config?.customDesign?.messageA78Time;
  }


  const onMessageSend = (value) => {
    let n = document.getElementsByClassName("btn btn-chat");
    for (let i = 0; i < n.length; i++) {
      n[i].disabled = true;
      onMouseLeave({ "target": n[i] });
    }
    props.actions.sendMessage(value);

  }


  const isActiveConversation = () => {
    let isClosed = (props.activeConversation && props.activeConversation.active != null && props.activeConversation.active !== undefined && props.activeConversation.active === false) || props.isConversationClosed;
    return !isClosed;
  }

  const data = isNullOrUndefined(props?.entry && props?.entry?.text_data?.names) ? [] : props?.entry && props?.entry?.text_data?.names;

  const isDropDowm = props?.entry?.text_data?.isDropDown;
  return (
    <>
      {!isDropDowm ? <div className={messageContainerClassName()}>
        {data?.length !== 0 && data.map((oneData, index) =>
          <button key={index} disabled={props.disabled} className="btn btn-chat btn-check"
            onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}
            style={messageBoxStyle()}
            {...(isActiveConversation() && { onClick: () => onMessageSend(oneData) })}>

            {oneData}
            <br/>
          </button>)}
        {props.isLastEntry && props.sentTimestamp && <div className="s360-message-time-received"
          style={messageTimeStyle()}>{dayjs.unix(Math.trunc(props.sentTimestamp / 1000)).format("DD MMM h:mm a")}</div>}
      </div> :
        <div
          className={messageContainerClassName()}
          //  style={messageContainerStyle()} // TODO: check implementation
        >
          <div
            className={localStorage.getItem("openInFullScreen") ? "select-container-a78-fs" : "select-container-a78"}>
            <select onChange={e => handleChange(e)}>
              {data.map((option, index) => (
                <option key={index} value={option}>{option}</option>
              ))}
            </select>
          </div>
          <div className="s360-message-cotainer-received">
            <button disabled={a78State.selected} className="s360-message-box-custom-a15-received"
              onClick={onSubmit} onMouseEnter={onMouseEnterButton}
              onMouseLeave={onMouseLeaveButton} style={messageBoxSubmitStyle()}>
              {"Submit"}
            </button>
          </div>
        </div>}
    </>

  )
}

export default MessageA78;
